import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { UserService } from 'src/app/services/user.service';
import { Table } from "primeng/table";
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { saveAs } from "file-saver/src/FileSaver";

@Component({
  selector: 'app-referral-income-details',
  templateUrl: './referral-income-details.component.html',
  styleUrls: ['./referral-income-details.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})
export class ReferralIncomeDetailsComponent implements OnInit {

  public lastTableLazyLoadEvent: LazyLoadEvent;
  refereeId: string;
  paginationOption: any[];
  referralName: any;
  searchBy: any[];
  searchby;
  startDate:Date;
  endDate:Date;
  refereeName: any;
  academyRefereeActivity: any;
  totalAcademyRefereeActivityRecords: any;
  loading: boolean;
  downloadFlg: boolean;
  downloadAcademiesList: any;
  @ViewChild("dt", { static: false }) public dt: Table;
  referralId: string;
  errorMessage: any;
  totalAmount: any;
  pageNumberFirst: any;
  pageLimitFirst: any;
  constructor(private userService: UserService,private activatedRoute:ActivatedRoute,private renderer: Renderer2,private router:Router) { }

  ngOnInit(): void {
    this.referralId = this.activatedRoute.snapshot.paramMap.get('id');
    this.refereeId = this.activatedRoute.snapshot.paramMap.get('refereeId');
    this.renderer.addClass(document.body, 'referral-Income-history-page');
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" }
    ];
    this.downloadFlg = false;
    var query = "&filterByReferalId="+this.refereeId+"&filterByDisable=false";

    this.userService.getAcademyReferrerList(this.referralId, query).subscribe(
     data => {
       this.refereeName = data.items[0]?.fullName;
       this.totalAmount = data.items[0]?.totalAmount;
     },
     err => {
       this.errorMessage = err.error.message;
     });

    const paginationData = JSON.parse(window.localStorage.getItem('referral-income-history'));
    this.pageNumberFirst = paginationData['page'];
    this.pageLimitFirst = paginationData['limit'];

    this.router.events.subscribe((events)=>{
      const initialReferralIncomeHistoryValues = { page: 1, limit: 10 };
      window.localStorage.setItem('referral-income-history',JSON.stringify(initialReferralIncomeHistoryValues));
    })
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'referral-Income-history-page');
  }

  loadAcademyRefereeActivity(event:LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    let query = '?filterByReferalId='+this.refereeId+'&filterByDisable=false';
    var pagenumber = 1;
    var params = "";
    var rows;
    if(event !== null && event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
      const referralIncomeHistoryValues = { page: pagenumber, limit: rows };
      window.localStorage.setItem('referral-income-history',JSON.stringify(referralIncomeHistoryValues));
    }

    if(event === null || event === undefined) {
      const paginationData = JSON.parse(window.localStorage.getItem('referral-income-history'));
      pagenumber = paginationData['page'];
      rows = paginationData['limit'];
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");      
    }

    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    this.pageNumberFirst = pagenumber;
    this.pageLimitFirst = rows;
    this.userService.getAcademyRefereeActivity(query).subscribe((data)=>{
      window.scroll(0,0);
      this.loading = false;
      if (this.downloadFlg === true) {
        this.exportExcelsheet(data.data.items);
      } else {
        this.academyRefereeActivity = data.data.items;
        this.totalAcademyRefereeActivityRecords = data.data.totalCount;
      }
    },
    err => {
        this.errorMessage = err.error.message;
    })
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt._first = 0;
    this.dt._rows = 10;
    const referralIncomeHistoryValues = { page: 1, limit: 10 };
    window.localStorage.setItem('referral-income-history',JSON.stringify(referralIncomeHistoryValues));
    this.loadAcademyRefereeActivity(null);
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadAcademyRefereeActivity(this.lastTableLazyLoadEvent);
  }

  exportExcelsheet(academyRefereeActivityData) {
    let propertiesRemove = ['id','wallettype','userData','userName','userEmail','userEmail','action','status','disable','tournamentplayerdata','created_by','createdBy',
                            'created_at','referalId','referalName','userMobile','contestdata'];
    this.downloadAcademiesList = academyRefereeActivityData;
    this.downloadAcademiesList.forEach((item)=>{
      if (item.created_at != "") {
        item["Created Date"] = moment(item.created_at).format(
          "DD-MM-YYYY"
        );
      }
      propertiesRemove.forEach((prop)=>{
        delete item[prop];
      })
    })
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadAcademiesList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Referee_Income_history");
    });
    this.downloadFlg = false;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

}
